import * as classNames from 'classnames';
import { DataService } from '../../../services/data_service';
import { disableKosten } from '../../../helpers/showKosten';
import { fn2, fn2nZ } from '../../../core/formatter/formatNumber';
import { formStyle, WFormData, WFormFieldArchiv, WFormFieldDateTime } from '../../../core/forms/WFormFramework';
import { IDs } from '../../../helpers/IDs';
import { isValid as isValidKraftstoff } from '../../../main/functions/validData';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { removeErrorLevelAddOn } from '../../../core/forms/helpers/errorLevelTools';
import style from './DialogKraftstoffVerbrauch.less';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { validateFieldUniversal } from '../functions/validateField';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { isConfigVorsteuerNetto } from '../co2_custom/getCustomFormConfig';

export interface DialogKraftstoffVerbrauchProps {
    data: any;
    standortSelected: any;
    jahr: any;
    values: any;
    onChange: (entityName: string, formValues: any) => void;
    onClose: () => void;
    reloadDataMonat?: (entityName: string) => void;
}

export interface DialogKraftstoffVerbrauchState {
    data: any;
    showSpinner: boolean;
}

export class DialogKraftstoffVerbrauch extends React.Component<DialogKraftstoffVerbrauchProps, DialogKraftstoffVerbrauchState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            showSpinner: false
        };
        this.onChange = this.onChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private disableKosten: boolean;
    private energietraeger: string;
    private energietraeger_tid: number;
    private FormData: any = new WFormData();
    private sumKosten: number;
    private sumVerbrauch: number;
    private isVorsteuerNetto: boolean = isConfigVorsteuerNetto(this.props.data);

    componentDidMount(): void {
        const row: any = this.props.values || {};
        const parent_tid = row.tid || 0;
        const kraftstoffe: any[] = this.props.data[IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE] || [];
        const data: any = {};
        kraftstoffe.filter((item: any) =>
            item.standort_tid_orig === this.props.standortSelected.tid
            && item.jahr === this.props.jahr
            && item.monat >= 1
            && item.parent_tid === parent_tid
        ).forEach((item: any, index: number) => data[index] = item);
        this.energietraeger_tid = typeof row.energietraeger_tid === 'number'
            ? row.energietraeger_tid
            : (typeof row.energietraeger_tid_orig === 'number' ? row.energietraeger_tid_orig : 0);
        this.energietraeger = (((this.props.data[`${IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE}_bundle`] || {}).energietraeger_tid || [])
            .find((item: any) => item.tid === this.energietraeger_tid) || {}).name || null;
        this.FormData.setBundle(this.props.data[`${IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE}_bundle`] || {});
        this.disableKosten = disableKosten(this.props.data);
        this.setState({ data });
    }

    getParentAbrechnungszeitraumBis(rows: any[]): number {
        let az = 0;
        rows.forEach((row: any) => {
            if (!isValidKraftstoff(row, IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE)) {
                return;
            }

            if (row.abrechnungszeitraum_bis > 0 && az < row.abrechnungszeitraum_bis) {
                az = row.abrechnungszeitraum_bis;
            }
        });
        return az;
    }

    getParentAbrechnungszeitraumVon(rows: any[]): number {
        let az = 0;
        rows.forEach((row: any) => {
            if (!isValidKraftstoff(row, IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE)) {
                return;
            }

            if (row.abrechnungszeitraum_von > 0 && (az === 0 || az > row.abrechnungszeitraum_von)) {
                az = row.abrechnungszeitraum_von;
            }
        });
        return az;
    }

    getValue(value: any): any {
        return typeof value !== 'undefined' && value !== null && !isNaN(+value) ? +value : null;
    }

    onChange(data: any): void {
        const index: number = typeof data.index === 'number' ? data.index : null;
        const value: any = data.value || null;
        const name: string = data.name || (this.state.data[index] || null);
        const values: any = this.state.data;
        if (!values[index] && value === null) {
            return;
        }
        values[index] = { ...values[index], [name]: value };
        this.setState({ data: values });
    }

    render(): JSX.Element {
        if (!this.state.data) {
            return null;
        }
        return (
            <div style={{overflowY: 'auto', paddingBottom: '45px'}}className={classNames(formStyle.sidebysideComplex, style.wrapper)}>
                {this.renderHeader()}
                {this.renderVerbraeuche()}
                {this.renderFooter()}
                {this.state.showSpinner && <WSpinner />}
            </div>
        );
    }

    renderButtons(): JSX.Element {
        return (
            <div
                className={style.buttons}
                style={{ width: 250, padding: 0, maxWidth: 'unset' }}
            >
                <WActionButton
                    disabled={this.state.showSpinner}
                    label='Werte speichern und übernehmen'
                    insideText='Werte speichern und übernehmen'
                    key='save'
                    action='save'
                    onAction={() => this.saveData()}
                    styleProps={{ height: 'auto', width: 182, marginRight: 10 }}
                />
                {/* <WActionButton
                    label='Schließen'
                    insideText='Schließen'
                    key='close'
                    action='delete'
                    onAction={this.props.onClose}
                /> */}
            </div>
        );
    }

    renderFooter(): JSX.Element {
        return (
            <div className={style.footer}>
                <div>Summen</div>
                <div>{fn2(this.sumVerbrauch)}</div>
                <div style={this.disableKosten ? { display: 'none' } : {}}>
                    {fn2nZ(this.sumKosten)}
                </div>
                {this.renderButtons()}
            </div>
        );
    }

    renderHeader(): JSX.Element {
        return (
            <div className={style.header}>
                <div>Datum</div>
                <div>Verbrauch</div>
                <div style={this.disableKosten ? { display: 'none' } : {}}>
                    {`Kosten (${this.isVorsteuerNetto ? 'netto' : 'brutto'}) [€]`}
                </div>
                <div>Rechnung</div>
                <div style={{ padding: '2px 0' }}>
                    {this.renderHilfeSymbol()}
                </div>
            </div>
        );
    }

    renderHilfeSymbol(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ marginTop: 2, marginLeft: -62 }}
                styleProps={{ margin: 0 }}
                label='Rechner - Kraftstoff'
                helpKey='dialog_rechner_kraftstoff'
                style={'theme_small'}
                type={'theme_info'}
                customElement={'Info'}
                editBar
                useTheme
            />
        );
    }

    renderRow(index: number): JSX.Element {
        const maxDate: Date = new Date(this.props.jahr, 11, 31);
        const minDate: Date = new Date(this.props.jahr, 0, 1);
        const values: any = this.state.data[index] || {};
        this.FormData.setAllValues({
            energietraeger_tid: this.energietraeger_tid,
            kosten: this.getValue(values.kosten),
            verbrauch: this.getValue(values.verbrauch)
        });

        return (
            <div className={style.fields}>
                <div>
                    <WFormFieldDateTime
                        label={null}
                        name='monat'
                        value={values.monat || null}
                        withTimePicker={false}
                        required
                        onValueChange={(name: string, input: any) => {
                            const value: number = input && input !== -1 ? input : null;
                            this.onChange({ index, name: 'monat', value });
                        }}
                        minDate={minDate}
                        maxDate={maxDate}
                        hideClockSetTime
                        autofill={false}
                        WActionButtonStyleProps={{
                            maxWidth: 25,
                            maxHeight: 25,
                            marginLeft: 5
                        }}
                    />
                    {!(values.monat || null) &&
                        <div
                            className={formStyle.warnSignDlgRechner}
                            style={{ top: 0, right: 37 }}
                            title='Bitte Feld "Datum" ausfüllen'
                        >
                            *
                        </div>
                    }
                </div>
                <div>
                    <input
                        name='verbrauch'
                        type='number'
                        value={values.verbrauch || (values.verbrauch === 0 ? 0 : null)}
                        required
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                    {this.renderValidation('verbrauch')}
                </div>
                <div style={this.disableKosten ? { display: 'none' } : {}}>
                    <input
                        name='kosten'
                        type='number'
                        value={values.kosten || (values.kosten === 0 ? 0 : null)}
                        required
                        onChange={(evt: any) => {
                            this.onChange({ index, name: evt.target.name, value: evt.target.value });
                        }}
                    />
                    {this.renderValidation('kosten')}
                </div>
                <div>
                    <WFormFieldArchiv
                        entity={IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE}
                        label={null}
                        name='rechnung'
                        value={values.rechnung || 0}
                        data={values}
                        onValueChange={(name: string, value: any) => {
                            this.onChange({ index, name, value });
                        }}
                        module={IDs.MOD_ETOOL}
                        layout='noneAutoSave'
                    />
                </div>
            </div>
        );
    }

    renderValidation(key: string): JSX.Element {
        const { text, type } = this.validateField(key);
        if (!text) {
            return null;
        }
        return (
            <div
                className={formStyle.warnSignDlgRechner}
                style={{ ...(type === 'warning' && { color: '#616468' }) }}
                title={text}
            >
                *
            </div>
        );
    }

    renderVerbraeuche(): JSX.Element[] {
        const n: number = Object.keys(this.state.data || {}).length;
        const rows: JSX.Element[] = [];
        const values: any = this.state.data || {};
        this.sumKosten = null;
        this.sumVerbrauch = 0;

        Object.keys(values).forEach((i: string) => {
            const value: any = values[i] || {};
            const kosten: number = Math.round((+value.kosten || 0) * 100) / 100;
            const verbrauch: number = +value.verbrauch || 0;
            const hasDatum: boolean = !!value.monat;
            const isValid: boolean = isValidKraftstoff(
                {
                    energietraeger_tid: this.energietraeger, kosten: typeof value.kosten !== 'undefined' ? value.kosten : null,
                    verbrauch: value.verbrauch
                },
                IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE
            );
            this.sumVerbrauch += isValid && hasDatum ? verbrauch : 0;
            this.sumKosten = isValid && hasDatum
                ? (value.kosten !== null ? Math.round((+this.sumKosten + kosten) * 100) / 100 : this.sumKosten)
                : this.sumKosten;
            rows.push(
                <React.Fragment key={`row-${i}`}>{this.renderRow(+i)}</React.Fragment>
            );
        });
        rows.push(
            <React.Fragment key={`row-${n}`}>{this.renderRow(n)}</React.Fragment>
        );

        return rows;
    }

    saveData(): void {
        const delList: any[] = [];
        const kraftstoffe: any[] = this.props.data[IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE] || [];
        const row: any = this.props.values || {};
        const parent_tid = row.tid || 0;
        const saveList: any[] = [];
        const timestamp = new Date().getTime() / 1000;
        const values: any = this.state.data || {};
        const energie_tid = typeof row.energietraeger_tid === 'number'
            ? row.energietraeger_tid
            : (typeof row.energietraeger_tid_orig === 'number' ? row.energietraeger_tid_orig : 0);
        const data = kraftstoffe
            ? kraftstoffe.filter((item: any) =>
                item.standort_tid_orig === this.props.standortSelected.tid
                && item.jahr === this.props.jahr
                && +item.monat >= 1
                && item.parent_tid === parent_tid
            ) : [];
        let sumKosten: number = null;
        let sumVerbrauch = 0;

        Object.keys(values).forEach((i: string) => {
            const value: any = values[i] || {};
            const datum = +value.monat || null;
            const hasDatum: boolean = !!datum;
            const kosten = this.getValue(value.kosten) !== null ? Math.round(value.kosten * 100) / 100 : null;
            const rechnung = +value.rechnung || 0;
            const rechnung_archiv_delete = value.rechnung_archiv_delete || 0;
            const rechnung_archiv_filename = value.rechnung_archiv_filename || null;
            const rechnung_archiv_rawdata = value.rechnung_archiv_rawdata || null;
            const tid: number = +value.tid || null;
            const found = data.find((item: any) => item.tid === (value.tid || null));
            const verbrauch = +value.verbrauch || 0;
            const isValid: boolean = isValidKraftstoff(
                {
                    energietraeger_tid: this.energietraeger, kosten: typeof value.kosten !== 'undefined' ? value.kosten : null,
                    verbrauch: value.verbrauch
                },
                IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE
            );
            sumVerbrauch += isValid && hasDatum ? verbrauch : 0;
            sumKosten = isValid && hasDatum
                ? (kosten !== null ? Math.round((+sumKosten + kosten) * 100) / 100 : sumKosten)
                : sumKosten;

            if (found) { // Wenn Datensatz schon vorhanden --> immer speichern
                if (datum) {
                    saveList.push({
                        tid,
                        parent_tid,
                        verbrauch: this.getValue(value.verbrauch),
                        kosten,
                        rechnung,
                        ...(rechnung_archiv_delete ? { rechnung_archiv_delete } : {}),
                        ...(rechnung_archiv_filename ? { rechnung_archiv_filename } : {}),
                        ...(rechnung_archiv_rawdata ? { rechnung_archiv_rawdata } : {}),
                        datum: timestamp,
                        monat: datum,
                        abrechnungszeitraum_von: datum,
                        abrechnungszeitraum_bis: datum,
                        energietraeger_tid: energie_tid
                    });
                } else {
                    delList.push({ tid });
                }
            } else if (datum && (verbrauch > 0 || kosten > 0 || rechnung > 0 || rechnung_archiv_rawdata)) {
                saveList.push({
                    parent_tid,
                    ...(this.getValue(value.verbrauch) !== null ? { verbrauch } : {}),
                    ...(kosten !== null ? { kosten } : {}),
                    rechnung,
                    ...(rechnung_archiv_delete ? { rechnung_archiv_delete } : {}),
                    ...(rechnung_archiv_filename ? { rechnung_archiv_filename } : {}),
                    ...(rechnung_archiv_rawdata ? { rechnung_archiv_rawdata } : {}),
                    datum: timestamp,
                    abrechnungszeitraum_von: datum,
                    abrechnungszeitraum_bis: datum,
                    energietraeger_tid: energie_tid,
                    jahr: this.props.jahr,
                    monat: datum,
                    standort_tid: this.props.standortSelected.tid
                });
            }
        });

        if (saveList.length > 0) {
            const pAzVon = this.getParentAbrechnungszeitraumVon(saveList);
            const pAzBis = this.getParentAbrechnungszeitraumBis(saveList);
            // Speichere Daten durch dataService.saveDataList
            this.setState({ showSpinner: true }, () => {
                this.dataService.saveDataList(IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, saveList, (sql: string, success: boolean) => {
                    this.setState({ showSpinner: false });
                    // Speichere Jahresdaten durch onChange
                    let valueYear = kraftstoffe.find((item: any) => item.tid === row.tid);
                    sumVerbrauch = Math.round(sumVerbrauch * 100) / 100;
                    sumKosten = Math.round(sumKosten * 100) / 100;
                    if (valueYear) { // Wenn Datensatz schon vorhanden --> immer speichern
                        valueYear._formKey = row._formKey;
                        valueYear.kosten = sumKosten;
                        valueYear.verbrauch = sumVerbrauch;
                        valueYear.datum = row.datum;
                        valueYear.abrechnungszeitraum_von = pAzVon;
                        valueYear.abrechnungszeitraum_bis = pAzBis;
                        valueYear.standort_tid = this.props.standortSelected.tid;
                        valueYear.energietraeger_tid = energie_tid;
                        this.props.onChange(IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, valueYear);
                    } else if (sumVerbrauch > 0 || sumKosten > 0) {
                        valueYear = {
                            _formKey: row._formKey,
                            ...(sumKosten !== null ? { kosten: sumKosten } : {}),
                            verbrauch: sumVerbrauch,
                            datum: row.datum,
                            abrechnungszeitraum_von: pAzVon,
                            abrechnungszeitraum_bis: pAzBis,
                            energietraeger_tid: energie_tid,
                            jahr: this.props.jahr,
                            standort_tid: this.props.standortSelected.tid
                        };
                        this.props.onChange(IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, valueYear);
                    }
                    this.dataService.delDataList(IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, delList, () => {
                        // reloadDataMonat ist die Reload-Funktion aus DateneingabeEnergiedatenKomplex
                        if (this.props.reloadDataMonat) {
                            delList.forEach((del: any) => {
                                // Wir löschen hier direkt die Daten in "props.data", da wir nicht die komplette "entity" neu laden wollen
                                const index: number = kraftstoffe.findIndex((item: any) => item.tid === del.tid);
                                kraftstoffe.splice(index, 1);
                            });
                            this.props.reloadDataMonat(IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE);
                        } else {
                            this.triggerService.fire('reload', IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE);
                        }
                        this.props.onClose();
                    });
                }, IDs.MOD_ETOOL);
            });
        } else {
            this.props.onClose();
        }
    }

    validateField(key: string): { text: string, type: string } {
        const name: string = (key || '').length
            ? (key || '').replace(/^\w/, (name: string) => name.toUpperCase())
            : null;
        const value: number = this.FormData.getValue(key);
        let text: string = null;
        let type: string = null;

        if (value === null) {
            text = `Bitte Feld "${name}" ausfüllen`;
            type = 'error';
        } else {
            text = removeErrorLevelAddOn(
                validateFieldUniversal(
                    IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, key, value, this.FormData, null, this.props.data,
                    (data: any) => type = (data || {}).type || null
                )
            );
        }

        return { text, type };
    }
}
